import { useRef, PropsWithChildren } from 'react';
import useResizeObserver from '@react-hook/resize-observer';
import { useSetAtom } from 'jotai';

import { pageWrapperSizeAtom } from '../../../../store/index.atom';
import useWheel from '../../../../hooks/useWheel';

import * as Styled from './index.styles';

export interface Props {
  totalPage?: number;
  isWheelDisabled?: boolean;
  updateNextThumbnails?: (page: number) => void;
  updatePrevThumbnails?: (page: number) => void;
}

const DesktopPageWrapper = ({
  totalPage,
  isWheelDisabled,
  updateNextThumbnails,
  updatePrevThumbnails,
  children,
}: PropsWithChildren<Props>) => {
  const setPageWrapperSize = useSetAtom(pageWrapperSizeAtom);

  /* pdf 이미지가 렌더링될 영역을 계산 */
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useResizeObserver(wrapperRef, ({ contentRect: { width, height } }) =>
    setPageWrapperSize({
      width,
      height,
    }),
  );

  /* 데스크탑 뷰어에서 스크롤시 페이지를 이동할 수 있도록 한다  */
  const handleWheel = useWheel({
    totalPage,
    updateNextThumbnails,
    updatePrevThumbnails,
  });

  return (
    <Styled.Wrapper
      ref={wrapperRef}
      onWheel={(e) => {
        if (isWheelDisabled) {
          return;
        }
        handleWheel(e);
      }}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
    >
      {children}
    </Styled.Wrapper>
  );
};

export default DesktopPageWrapper;
